// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
//MD5加密
import md5 from 'js-md5';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import '@/assets/css/pay-theme.scss';

//全局引入自定义组件
import '@/assets/css/reset.css';
import router from './router';
import store from './store';
import i18n from './i18n';
import bootstrap from './core';
import Http from './plugins/http.js';
import cusInstall from './plugins/cus-component';
import VueMeta from 'vue-meta';

import './router/permission';
import './utils/filter';
// 引用api文件
// import api from './api/index';
// Vue.prototype.$api = api;
import outToExcel from './utils/outToExcel';
import axios from 'axios';
import directives from "@/utils/directives";

Vue.use(VueMeta, {
  keyName: 'metaInfo',
  attribute: 'data-vue-meta',
  ssrAttribute: 'data-vue-meta-server-rendered',
  tagIDKeyName: 'vmid',
  refreshOnceOnNavigation: true,
  contentSecurityPolicy: {
    defaultSrc: ["'self'"],
    scriptSrc: ["'self'", "'unsafe-inline'"],
    styleSrc: ["'self'", "'unsafe-inline'"],
    imgSrc: ["'self'"],
    connectSrc: ["'self'"],
    fontSrc: ["'self'"],
    objectSrc: ["'none'"],
    mediaSrc: ["'self'"]
  }
});
Vue.prototype.outToExcels = outToExcel;
Vue.prototype.$http = Http;
Vue.prototype.$md5 = md5;
Vue.prototype.$defaultPaginationSize = 100;
Vue.prototype.keys = {
  current_user: {
    token: 'token',
    user: 'user',
    menus: []
  }
};
Vue.prototype.$getStatus = (list, code) => {
  if (!list) return '';
  let az = list.filter((it) => it.value == code);
  let [item] = az;
  return item ? item.label : '';
};
Vue.prototype.$axios = axios;
ElementUI.Dialog.props.closeOnClickModal.default = false;
Vue.use(ElementUI);
Vue.use(cusInstall);

// Vue.use(MyServerHttp);
Vue.config.productionTip = false;

if (process.env.NODE_ENV === 'production') {
  console.log = () => { };
}

// 注册全局指令
Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key]);
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  created: bootstrap,
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js